import { Injectable } from '@angular/core';
import { ScheduledCampaignsModel } from './scheduled-campaigns-model';

@Injectable({
  providedIn: 'root'
})

export class ScheduledCampaignsModelAdapter {

  adapt(item: any): ScheduledCampaignsModel {
    return new ScheduledCampaignsModel(item);
  }
  
  createEmpty(){
    return new ScheduledCampaignsModel({
      TriggerId: 0,
      MessageName: '',
      ListName: '',
      SentSMSsScheduledDate: '',
      MessageId: 0,
      MessageType: 0
    });
  }
}